/**
 * Firebase Client for OilWellX
 * Initialized Firebase app with Auth, Firestore, Storage, and Functions
 */

import { initializeApp, FirebaseApp } from 'firebase/app';
import {
  getAuth,
  Auth,
  connectAuthEmulator,
} from 'firebase/auth';
import { 
  Firestore, 
  connectFirestoreEmulator,
  initializeFirestore,
} from 'firebase/firestore';
import { getStorage, FirebaseStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, Functions, connectFunctionsEmulator } from 'firebase/functions';
import { firebaseConfig, useEmulator, emulatorConfig } from './config';

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Auth - simple browser initialization
export const auth: Auth = getAuth(app);

// Initialize Firestore with DEFAULT database (switched from named 'oilwellx' on Dec 2025)
// Use long-polling for better browser compatibility
export const db: Firestore = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

// NavigatorX data lives in the named Firestore database "navigatorx" of the same project.
// The superadmin NavigatorX panels and the navigatorX*Service modules open it through this
// handle; `db` stays the (default) database for OilWellX data.
export const NAVIGATORX_DATABASE_ID = 'navigatorx';
export const navDb: Firestore = initializeFirestore(
  app,
  { experimentalForceLongPolling: true },
  NAVIGATORX_DATABASE_ID,
);


// Initialize Storage and Functions
export const storage: FirebaseStorage = getStorage(app);
export const functions: Functions = getFunctions(app);

// Connect to emulators if in development
if (useEmulator) {
  connectAuthEmulator(auth, `http://${emulatorConfig.auth.host}:${emulatorConfig.auth.port}`);
  connectFirestoreEmulator(db, emulatorConfig.firestore.host, emulatorConfig.firestore.port);
  connectFirestoreEmulator(navDb, emulatorConfig.firestore.host, emulatorConfig.firestore.port);
  connectStorageEmulator(storage, emulatorConfig.storage.host, emulatorConfig.storage.port);
  connectFunctionsEmulator(functions, emulatorConfig.functions.host, emulatorConfig.functions.port);
}


export default app;
